import styled from "styled-components";
import ProductListItem from "./ProductListItem";
import { useSelector } from "react-redux";
import CategoryListItem from "./CategoryListItem";
import { useEffect, useState } from "react";


const  CategoryList = styled.div`

display: flex;
flex-direction: column;
padding: -0.5rem 1rem;
justify-content: center;
align-items: center;

`


export const ProductListFilterNew = (props) => {

  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals
    scrollTo(0, 0);
  }, []);

  const [menuMobileOpen, setMenuMobileOpen] = useState(false);

    const { handleApplyFilters,sort,setSort } = props;
    const [enableApplyFilter, setEnableApplyFilter] = useState(false);

  const isMobile = window.innerWidth <= 900;
  const productsList = useSelector(
      (state) => state?.allProducts?.productsList || {}
    );
    
  
    const selectedFilters = useSelector(
      (state) => state?.allProducts?.filters || {}
    );

    console.log(selectedFilters, "selectedFilters");
  
  const { filters = [] } = productsList || {};

 useEffect(() => {
    let filterKeys = Object.keys(selectedFilters);
    let enabledCTA = filterKeys?.some((key) => {
      return selectedFilters[key]?.length > 0;
    });
    if (enabledCTA) {
      setEnableApplyFilter(true);
    } else {
      setEnableApplyFilter(false);
    }
  }, [selectedFilters]);
  

    const ProductListFilter = styled.div`
    display: flex;
    flex-direction: column;
    padding: .5rem 1rem;
    justify-content: center;
    align-items: center;
   
    width: 251px;
    border: 1px solid rgba(73, 73, 73, 0.26);
    border-radius: 8px;
    margin-right: .5rem;
    
  
    
    `

 const size = [
    { id: 1, name: "S" },
    { id: 2, name: "M" },
    { id: 3, name: "L" },
    { id: 4, name: "XL" },
    { id: 5, name: "XXL" },
  ];

   const brands = [
    { id: 1, name: "S" },
    { id: 2, name: "M" },
    { id: 3, name: "L" },
    { id: 4, name: "XL" },
    { id: 5, name: "XXL" },
  ];
   const price = [
    { id: 1, name: "2000" },
    { id: 2, name: "5000" },
    { id: 3, name: "1000" },
    { id: 4, name: "500" },
    { id: 5, name: "800" },
  ];
  const categories = useSelector((state) => state.categories || []);
  console.log(categories, "categories");

  const FilterMobile = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;  
  width: 100%;
  height: 41px;
.filter-icon-mobileview{
display: flex;
justify-content: flex-end;
padding: 0.5rem 1rem;
width: 100vw;
margin-bottom: 1rem;
border: 1px solid rgba(73, 73, 73, 0.26);
margin-top: 0.5rem;
border-radius: 8px;
}
  `
  const ApplyFilterButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  width: 100%;
  height: 35px;
  border: none;
  outline: none;
  background-color:rgb(128, 211, 39);
  color: #fff;
  cursor: pointer;
 


  `
  const ApplyFilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  cursor: pointer;
  gap: 0.25rem;
  `

  const MenuMobileMain = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #fff;
  z-index: 5000;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top:1rem;
  padding-left: 1rem;
  padding-right: 1rem;
  
  `

  const PriceSort = styled.div`
  display:flex;
  flex-direction:row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 35px;
  gap: 0.25rem;
  font-size: 12px;
  weight: 500;
  font-family: "Ancizar", sans-serif;
  width: 100%;
  text-align: left;


  weight: 600;
  `
  const PriceItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family:"Ancizar", sans-serif;
  font-size: 12px;
  width: 100%;
  border:1px solid rgba(73, 73, 73, 0.26);
  height: 35px;
  cursor: pointer;
  &:hover {
    background-color: rgba(128, 211, 39, 0.42);
    color: #333;
  }
  `
  const FilteritemsList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin-top: 3rem;
  `

  useEffect(() => {
    let filterKeys = Object.keys(selectedFilters);
    let enabledCTA = filterKeys?.some((key) => {
      return selectedFilters[key]?.length > 0;
    });
    if (enabledCTA) {
      setEnableApplyFilter(true);
    } else {
      setEnableApplyFilter(false);
    }
  }, [selectedFilters]);

  const PriceSortMain = styled.p`
  font-size:1rem;
  font-family: 'Ancizar Sans', sans-serif;
  color: #333;
  font-weight: 500;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  font-weight: 600;
  font-size: 16px;
  width: 100%;

  `


    return (
     isMobile ? <>
     <FilterMobile>
     <div className="filter-icon-mobileview" onClick={() => setMenuMobileOpen(!menuMobileOpen)}>
      Filter 
     </div>
     </FilterMobile>

     {menuMobileOpen ? <MenuMobileMain>

       <ApplyFilterContainer>
           <ApplyFilterButton onClick={handleApplyFilters} disabled={!enableApplyFilter} className="applybutton">
      Apply
     </ApplyFilterButton>
      <ApplyFilterButton onClick={handleApplyFilters} disabled={!enableApplyFilter} className="applybutton">
      Clear Filter
     </ApplyFilterButton>
        </ApplyFilterContainer>

         <FilteritemsList>
          {filters?.length > 0 && filters?.map((filter,index) =>{

        return(

         <ProductListItem filter = {filter} selectedFilters={selectedFilters} last={index === filters.length - 1} isMobile={isMobile} />

        )
       } )}
         </FilteritemsList>


 <PriceSort>PRICE</PriceSort>

<PriceSort>
       
       <PriceItem  style={{backgroundColor:sort=='sortBy_priceHighToLow'?'transparent':'rgb(170 211 127)'}}  onClick={()=>{setSort('sortBy_priceLowToHigh')}}>Lowest First</PriceItem>
           <PriceItem  style={{backgroundColor:sort!='sortBy_priceHighToLow'?'transparent':'rgb(170 211 127)'}}    onClick={()=>{setSort('sortBy_priceHighToLow')}}>Highest First</PriceItem>

      </PriceSort>
     </MenuMobileMain> :<></>}

    


     
     </>:    
    <>
     
     
     <ProductListFilter>
        <ApplyFilterContainer>
           <ApplyFilterButton onClick={handleApplyFilters} disabled={!enableApplyFilter} className="applybutton">
      Apply
     </ApplyFilterButton>
      <ApplyFilterButton onClick={handleApplyFilters} disabled={!enableApplyFilter} className="applybutton">
      Clear Filter
     </ApplyFilterButton>
        </ApplyFilterContainer>
       {filters?.length > 0 && filters?.map((filter,index) =>{

        return(

         <ProductListItem filter = {filter} selectedFilters={selectedFilters} last={index === filters.length - 1} />

        )
       } )}


          
       {/*    <CategoryList>
            {categories.map((category) => (
              <CategoryListItem
                key={category.id}
                title={category.name}
                list={category.children || []}
              />
            ))}

          </CategoryList> */}
      <PriceSortMain>PRICE</PriceSortMain>
      <PriceSort>
       
       <PriceItem  style={{backgroundColor:sort=='sortBy_priceHighToLow'?'transparent':'rgb(170 211 127)'}}  onClick={()=>{setSort('sortBy_priceLowToHigh')}}>Lowest First</PriceItem>
           <PriceItem  style={{backgroundColor:sort!='sortBy_priceHighToLow'?'transparent':'rgb(170 211 127)'}}    onClick={()=>{setSort('sortBy_priceHighToLow')}}>Highest First</PriceItem>

      </PriceSort>
    </ProductListFilter>
    </>
  );
}

